import React, { Component } from "react";
import { connect } from "react-redux";
import * as selector from "../../../../common/selectors";
import * as enrolGIRONowSelector from "../../../../common/selectors/enrolGIRONow";
import * as enrolGIRONowAction from "../../../../common/actions/enrolGIRONow";
import CustomBoardRenewal from "../../../components/CustomBoardRenewal";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../components/CustomText";
import Color from "../../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomButton from "../../../components/CustomButton";
import _ from "lodash";
import AuthManager from "../../../../utils/AuthManager";
import Image from "../../../../assets";
import { Helmet } from "react-helmet";
import CustomBoardGiro from "../../../components/CustomBoardGiro";
import CustomEnrolGiroNowV2 from "../../../components/CustomEnrolGiroNowV2";
import LoadingOverlay from "../../../components/LoadingOverlay";
import CustomPaper from "../../../components/CustomPaper";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";

const screenW = window.screen.width + "px";
const screenH = "450" + "px";

class ProcessSubmitStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      policyNo: "",
      isOnClickNext: false,
      error: false,
      errorMsg: "",
      localDDARef: "",
      localBankTransId: "",
      localGiroIntervalTime: "",
      localRetryCount: "",
      testAction: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    localStorage.setItem("EnrolGiroFooter", "true");
    var ddaRefNo = this.getUrlVars()["DDARefNo"];
    var bankTransId = this.getUrlVars()["BankTransId"];
    var giroIntervalTime = this.getUrlVars()["GiroIntervalTime"];
    var giroRetryCount = this.getUrlVars()["GiroRetryCount"];
    this.setState({
      localDDARef: ddaRefNo,
      localBankTransId: bankTransId,
      localGiroIntervalTime: giroIntervalTime,
      localRetryCount: giroRetryCount,
    });
    // localStorage.setItem("DDARefNo", ddaRefNo);
    // localStorage.setItem("BankTransId", bankTransId);
    // if (giroIntervalTime !== undefined) {
    //   localStorage.setItem("GiroIntervalTime", giroIntervalTime);
    // }
    // if (giroRetryCount !== undefined) {
    //   localStorage.setItem("GiroRetryCount", giroRetryCount);
    // }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const {
      localDDARef,
      localBankTransId,
      testAction,
      localRetryCount,
      localGiroIntervalTime,

    } = this.state;
    const { getGiroSubmitCallBackExistData,getGiroSubmitCallBackExistDataFunction,confirmPayEddaGiRenewal } = this.props;
    const data = enrolGIRONowSelector.getGiroSubmitCallBackExistDataData(
      this.props.getGiroSubmitCallBackExistData
    );
    const status = enrolGIRONowSelector.getGiroSubmitCallBackExistDataStatus(data);
    const redirectUrl = enrolGIRONowSelector.getGiroSubmitCallBackExistDataRedirectUrl(
      data
    );
    if (localDDARef !== "" && localBankTransId !== "") {
      if (testAction === false) {
        getGiroSubmitCallBackExistDataFunction(localDDARef, localBankTransId);
        this.setState({ testAction: true });
        console.log("status",)
      }
    }
    if (
      prevProps.getGiroSubmitCallBackExistData !== this.props.getGiroSubmitCallBackExistData
    ) {
      console.log("status",status)
      if (
        parseInt(localRetryCount) > 0
      ) {
        console.log("status",status)
        this.setState({ localRetryCount: parseInt(localRetryCount) - 1 });
        if (status === false) {
          setTimeout(function () {
            getGiroSubmitCallBackExistDataFunction(localDDARef, localBankTransId);
          }, parseInt(localGiroIntervalTime));
        } else {
        const giroSubmitCallBackExistData = enrolGIRONowSelector.getGiroSubmitCallBackExistDataData(
          this.props.getGiroSubmitCallBackExistData
        );

        const giroFlow = enrolGIRONowSelector.getGiroSubmitCallBackExistDataGiroFlow(giroSubmitCallBackExistData);

        const giroCallBackData = enrolGIRONowSelector.getGiroCallBackDataData(
          this.props.getGiroCallBackData
        );
        
        const orderNumber = enrolGIRONowSelector.getGiroCallBackDataOrderNumber(
          giroCallBackData
        );

        console.log("GiroFlow",data,giroFlow,this.props.getGiroCallBackData)

        if(giroFlow === 2){
          confirmPayEddaGiRenewal(window.localStorage.getItem("orderNumber"))
        } else {
          window.location.href = redirectUrl;
        }
        }
      } else {
        if(window.localStorage.getItem("GiroFlow") === "2" ){
          if(window.localStorage.getItem("MyToken")){
            window.location.href = process.env.REACT_APP_TIQ_BASE_URL + `/#/PaymentResult`;
          }else{
            this.props.history.push("/PaymentStatus");
          }
          return;
        }
        this.props.history.push("/GiroStatus?status=fail");
      }
    }

    if (
      prevProps.confirmPayEddaGiRenewalData !== this.props.confirmPayEddaGiRenewalData
    ) {
      const data = enrolGIRONowSelector.confirmPayEddaGiRenewalDataData(
        this.props.confirmPayEddaGiRenewalData
      );
      const renewalFlow = enrolGIRONowSelector.confirmPayEddaGiRenewalDataRenewalFlow(
        data
      );

      const giroCallBackData = enrolGIRONowSelector.getGiroCallBackDataData(
        this.props.getGiroCallBackData
      );
      const orderNumber = enrolGIRONowSelector.getGiroCallBackDataOrderNumber(
        giroCallBackData
      );
       console.log("datadatadatadata",data,this.props.confirmPayEddaGiRenewalData,renewalFlow)
      if(renewalFlow === 1){
        this.props.history.push(`/PaymentStatus?orderNumber=${window.localStorage.getItem("orderNumber")}`);
      }
      if(renewalFlow === 2){
        //this.props.history.push(`/PaymentStatus?orderNumber=${orderNumber}`);
        window.location.href = process.env.REACT_APP_TIQ_BASE_URL + `/#/PaymentResult?orderNumber=${window.localStorage.getItem("orderNumber")}`;
      }
      
      window.localStorage.removeItem("orderNumber");
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onChangePolicyNo = (event) => {
    this.setState({ policyNo: event.target.value });
  };

  onClickNext = () => {
    const { history } = this.props;
    const { policyNo } = this.state;
    this.setState({ isOnClickNext: true });
    // if (!this.validateTextInput()) {
    //   AuthManager.setPolicyNo(policyNo);

    //   history.push("/EnrolGiroInfo");
    // }
    // history.push("/EnrolGiroInfo");
    if (this.state.policyNo === "") {
    }
    const { getDDAPolicy } = this.props;
    if (this.state.policyNo === "") {
      this.setState({
        error: true,
        errorMsg: "You must specify a value for this required field.",
      });
    } else {
      getDDAPolicy(this.state.policyNo,"");
    }
  };

  onClickHere = () => {
    window.open(process.env.REACT_APP_LOGIN_BASE_URL);
  };

  validateTextInput = () => {
    const { policyNo } = this.state;
    return _.isEmpty(policyNo);
  };

  onClickBack = () => {
    window.history.back();
  };

  getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  };

  renderChildren = () => {
    const { classes } = this.props;
    const { policyNo, isOnClickNext, errorMsg, error } = this.state;
    return (
      <Grid>
        <LoadingOverlay loading={true} />
      </Grid>
    );
  };

  render() {
    const { classes } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        <Helmet>
          <title>Enrol GIRO Now</title>
        </Helmet>
        {/* <div className={classes.headerStyle} style={{display:"inline-block"}}>
          <div  >
            <img src={Image.renewalHeader} style={{height:"42px"}} />
          </div>
          <div style={{textAlign:"center"}}>
            <CustomText design={classes.headerTextStyle}>
              Policy Renewal
            </CustomText>
          </div>
        </div> */}

        {window.innerWidth < 601 ? (
          <CustomEnrolGiroNowV2
            children={this.renderChildren()}
            height={height}
            width={width}
          />
        ) : (
          false
        )}
        {window.innerWidth > 600 ? (
          <AppBar
            position="sticky"
            className={classes.appBar}
            style={{ background: "#333333" }}
          >
            <Toolbar
              className={classes.toolbarStyle}
              style={{
                justifyContent: "space-between",
                //alignItems: "center",
                display: "flex-start",
                flexDirection: "row",
                marginLeft: "5em",
              }}
            >
              <img
                src={Image.nonDirectClientEtiqaLogo}
                style={{ width: 112, height: 60 }}
              />
            </Toolbar>
          </AppBar>
        ) : (
          false
        )}
        {window.innerWidth > 600 ? this.renderChildren() : false}

        {this.props.getDDAPolicyLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
        {this.props.getGiroSubmitCallBackExistLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
        
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#f4f4f4",
    maxHeight: "100vh",
    minHeight: "100vh",
    // backgroundImage:
    //   window.innerWidth < 601 ? false : `url(${Image.enrolGiroBg})`,
    // backgroundSize: window.innerWidth < 601 ? false : `${screenW} ${screenH}`,
    // backgroundPosition: window.innerWidth < 601 ? false : "bottom center",
    // backgroundRepeat: window.innerWidth < 601 ? false : "no-repeat",
    backgroundImage: `url(${Image.enrolGiroBg})`,
    backgroundSize: `${screenW} ${screenH}`,
    backgroundPosition: "bottom center",
    backgroundRepeat: "no-repeat",
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyle: {
    ...getFontWeight("400"),
    fontSize: "16px",
    color: "#424143",
    fontFamily:"Muli",
  },
  textInputContainer: {
    height: 45,
    marginTop: 7,
  },
  nextButtonStyle: {
    //width: 150,
    marginTop: 10,
    marginBottom: 10,
    height: 40,
    fontFamily:"Muli",
    fontSize: "18px",
  },
  nextTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  renewNowTextStyle: {
    fontWeight: "bold",
    fontFamily:"Muli",
    fontSize: 22,
    textAlign: "center",
    marginBottom: 10,
    marginTop: 30,
  },
  renewNowTextStyleV2: {
    ...getFontWeight("400"),
    fontSize: 17,
    textAlign: "center",
    fontFamily:"Muli",
    marginBottom: 45,
  },
  errorTextStyle: {
    color: "red",
  },
  backButton: {
    width: 120,
    marginTop: 0,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  headerStyle: {
    backgroundColor: "#5b5b5b",
  },
  headerTextStyle: {
    color: "white",
    textAlign: "center",
    fontSize: "28px",
  },
  paper: {
    // overflow: "auto",
    //backgroundColor: "#f4f4f4",
    marginTop: window.innerWidth < 601 ? false : "6%",
    marginLeft: window.innerWidth < 601 ? false : "30%",
    marginRight: window.innerWidth < 601 ? false : "30%",
  },
});

function mapStateToProps(state) {
  return {
    getGiroSubmitCallBackExistData: selector.getGiroSubmitCallBackExistData(state),
    getGiroSubmitCallBackExistLoading: selector.getGiroSubmitCallBackExistLoading(state),
    getGiroSubmitCallBackExistStatus: selector.getGiroSubmitCallBackExistStatus(state),
    getGiroCallBackData: selector.getGiroCallBackData(state),

    confirmPayEddaGiRenewalData: selector.confirmPayEddaGiRenewalData(state),
    confirmPayEddaGiRenewalLoading: selector.confirmPayEddaGiRenewalLoading(state),
    confirmPayEddaGiRenewalStatus: selector.confirmPayEddaGiRenewalStatus(state),
    
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getGiroSubmitCallBackExistDataFunction: (ddaRefNo, bankTransId) =>
      dispatch(
        enrolGIRONowAction.getGiroSubmitCallBackExistData(ddaRefNo, bankTransId)
      ),
      confirmPayEddaGiRenewal: (orderNumber) =>
      dispatch(
        enrolGIRONowAction.confirmPayEddaGiRenewal( orderNumber)
      ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(ProcessSubmitStatus)));
